<template>
  <div class="ui-checkbox">
    <span class="el-checkbox__input" :class="{'is-checked': value}">
      <span class="el-checkbox__inner">
        <input class="el-checkbox__original" type="checkbox" v-model="value">
      </span>
    </span>
    <label class="ui-checkbox__label title">{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: 'box',
  props: {
    label: {
      type: String
    },
    value: {
      type: Boolean
    }
  }
}
</script>
